var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5419_1542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.849 7.68005L21.98 7.00005H22.001V2.00005H20.001V5.45105L13.849 0.637047C12.761 -0.214953 11.24 -0.214953 10.152 0.637047L1.151 7.68005C0.42 8.25205 0 9.11405 0 10.043V24.0001H9V15C9 14.449 9.448 14 10 14H14C14.552 14 15 14.449 15 15V24.0001H24V10.043C24 9.11405 23.58 8.25205 22.849 7.68005ZM22 22.0001H17V15C17 13.346 15.654 12 14 12H10C8.346 12 7 13.346 7 15V22.0001H2V10.043C2 9.73305 2.14 9.44605 2.384 9.25505L11.384 2.21205C11.747 1.92805 12.253 1.92805 12.616 2.21205L21.616 9.25505C21.86 9.44605 22 9.73305 22 10.043V22.0001Z",
    fill: "#FC981B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_1542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/Home_icon.094c3876405530a03976de45ca1a0d35.svg";
export { ForwardRef as ReactComponent };